import { isDevelopment } from 'src/tpbp-core/utils/common.utils'
import {
  DEFAULT_LOCALE,
  FRENCH_LOCALE,
  dateTimeFormats,
  numberFormats,
} from 'src/tpbp-core/utils/formatter/config'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { messages } from '../../locales'
import frMessagesMinor from '../../locales/frMessagesMinor'

Vue.use(VueI18n)

const locales = {
  [FRENCH_LOCALE]: messages,
}

export const vueI18n = new VueI18n({
  locale: FRENCH_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: locales,
  dateTimeFormats,
  numberFormats,
  pluralizationRules: {
    [FRENCH_LOCALE]: function (value, count) {
      const integerValue = Math.floor(value)

      if (integerValue === 0) {
        return 0
      }
      const pluralIndex = count - 1
      const singularIndex = pluralIndex > 0 ? pluralIndex - 1 : pluralIndex

      return integerValue > 1 ? pluralIndex : singularIndex
    },
  },
})

/** @deprecated should not be used directly, use translate instead */
export function $t(key: string, values?: VueI18n.Values | undefined): string {
  return translate(key, values)
}

/* eslint-disable no-restricted-properties */

// eslint-disable-next-line @typescript-eslint/no-base-to-string
export function translate(
  key: string,
  values?: VueI18n.Values | undefined,
): string {
  const result = vueI18n.t(key, values)
  if (typeof result === 'string') {
    return result
  }
  if (isDevelopment) {
    // can not use logger.warn() here since it uses hasFeature
    // eslint-disable-next-line no-console
    console.warn(`i18n key '${key}' has been forced into string`)
  }
  // eslint-disable-next-line @typescript-eslint/no-base-to-string
  return result.toString()
}

export type Translater = typeof translate

export const $tc = vueI18n.tc.bind(vueI18n)

export const $te = vueI18n.te.bind(vueI18n)

export const $d = vueI18n.d.bind(vueI18n)

export const $n = vueI18n.n.bind(vueI18n)
/* eslint-enable no-restricted-properties */

export function injectMinorLocales() {
  // eslint-disable-next-line no-restricted-properties
  vueI18n.mergeLocaleMessage(FRENCH_LOCALE, frMessagesMinor)
}
